<template>
  <div class="w-full">
    <button
      v-if="mini"
      class="font-bold uppercase focus:outline-none text-12 lg:text-14 lg:leading-1.25 py-8 px-4 flex
             justify-between cursor-pointer items-center shadow-none bg-transparent"
      :class="isMiniBtnDisabled ? `text-dark-gray` :
      `transform transition duration-300 hover:text-orange`"
      :disabled="isMiniBtnDisabled"
      @click="addToCart">
      <span v-if="!isLoading" class="relative">
        <i  class="far fa-shopping-cart text-lg absolute top-0 left-0"></i>
        <i  class="far fa-shopping-cart text-lg stroke-icon"></i>
      </span>
      <i v-if="isLoading" class="ml-10 text-gray text-20 fas fa-spinner fa-spin"></i>
    </button>

    <button
      v-else
      class="btn py-20 w-full text-base lg:text-xl"
      :class="isLoading ? `cursor-wait bg-gray`: isDisabled ? `bg-dark-gray cursor-default` : `cursor-pointer btn-primary-black`"
      :disabled="isDisabled"
      @click="addToCart">
      <i class="mr-12 fa-duotone fa-solid fa-pallet-box" v-show="status === 'sold'"></i> 
      <i class="mr-12 far fa-shopping-cart" v-show="status !== 'sold'"></i> {{ label }}
      <i v-if="isLoading" class="ml-10 text-white text-20 fas fa-spinner fa-spin"></i>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    artwork: {required: true},

    // Values: available, reserved, in-cart
    status: {
      type: String,
      required: true,
    },

    mini: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
    }
  },

  methods: {
    addToCart() {
      window.dataLayer.push({
        event: 'add-to-cart',
        artwork: {
          id: this.artwork.slug,
          title: this.artwork.title,
          price: this.artwork.discounted_price ?? this.artwork.original_price,
        }
      })
      if (this.status === 'available') {
        this.isLoading = true
        axios
          .post(`/web/api/cart/${this.artwork.slug}`)
          .then(({data}) => {
            this.$root.$refs.notification.notify({
              title: 'Added to cart!',
              message: 'The selected artwork is added to your cart and reserved for one hour',
              type: 'warning-dark',
            })
            this.$emit('added', data.data)
            window.TheCartLink.increment()
          })
          .catch((error) => {
            console.log(error.response)
            if (error.response.data.message) {
              alert(error.response.data.message)
            } else {
              alert('Unable to add artwork to cart. Please try again later.')
            }
          })
          .finally(() => this.isLoading = false)
      } else if (this.status === 'in-cart') {
        this.isLoading = true
        window.location = '/cart'
      }
    },
  },

  computed: {
    label() {
      if (this.status === 'available') {
        return 'Add to Cart'
      }

      if (this.status === 'in-cart') {
        return 'Checkout'
      }

      if (this.status === 'reserved') {
        return 'Already Reserved'
      }

      if (this.status === 'sold') {
        return 'Sold'
      }
    },

    isDisabled() {
      return this.isLoading || this.status !== 'available' && this.status !== 'in-cart'
    },

    isMiniBtnDisabled() {
      return this.isLoading || this.status !== 'available'
    }
  }
}
</script>

<style lang="scss" scoped>
.stroke-icon {
  text-shadow:
    -1px -1px 0 #fff,
    1px -1px 0 #fff,
    -1px 1px 0 #fff,
    1px 1px 0 #fff;
  -webkit-text-stroke: 10px white;
}
</style>
